import _compact from "lodash/compact";
import { BreakdownPermissions, userHasRole } from "shared-auth";

export function getCastingQuickLinks() {
  const canCreateBreakdown = userHasRole(BreakdownPermissions.Create);

  return _compact([
    canCreateBreakdown && {
      text: "common:nav.links.createBreakdown",
      href: "/casting/create-breakdown",
    },
    canCreateBreakdown && {
      text: "common:nav.links.draftBreakdowns",
      href: "/casting/active-breakdowns",
    },
    canCreateBreakdown && {
      text: "common:nav.links.projectFolders",
      href: "/casting/projects",
    },
    {
      text: "common:nav.links.performerSearch",
      href: "/casting/performers",
    },
    canCreateBreakdown && {
      text: "common:nav.links.myAgentsList",
      href: "/casting/agent-lists",
    },
    {
      text: "common:nav.links.myShortlists",
      href: "/casting/shortlists",
    },
    {
      text: "common:nav.links.contacts",
      href: "https://www.spotlight.com/contacts",
    },
    canCreateBreakdown && {
      text: "common:nav.links.industryForumArchive",
      href: "https://www.spotlight.com/the-spotlight-conference/",
    },
    canCreateBreakdown && {
      text: "common:nav.links.digitalShowcase",
      href: "https://spotlight-showcase.com",
    },
    canCreateBreakdown && {
      text: "common:nav.links.performanceCalendar",
      href: "https://calendar.spotlight.com/",
    },
    !canCreateBreakdown && {
      text: "common:nav.links.industryResources",
      href: "https://www.spotlight.com/help-and-faqs/links-for-professionals-on-spotlight",
    },
  ]);
}

export const castingDirectorInactiveQuickLinks = [
  {
    text: "common:nav.links.contacts",
    href: "https://www.spotlight.com/contacts",
  },
  {
    text: "common:nav.links.industryResources",
    href: "https://www.spotlight.com/help-and-faqs/links-for-professionals-on-spotlight",
  },
];

const testUtilsLinkHrefs = [
  "https://spotlightuk.typeform.com/to/z7dZxceX",
  "/casting/performers",
  "/casting/shortlists",
  "/contacts",
  "https://www.spotlight.com/help-and-faqs/links-for-professionals-on-spotlight",
];

export const castingDirectorPublishBreakdownOnlylinks =
  getCastingQuickLinks().filter(
    (defaultLink) => !testUtilsLinkHrefs.includes(defaultLink.href)
  );
